import { useMutation } from 'react-query';
import { useFetchMutation } from '../../../helpers/api';

export type UseDeleteMilestoneActionsArguments = {
  caseId: string;
  actionId: string;
  successToastMessage: string;
};

type UseDeleteMilestoneActionsResult = {
  deleteMilestoneActionsMutate: (
    data: UseDeleteMilestoneActionsArguments,
  ) => void;
  isLoading: boolean;
  isSuccess: boolean;
  error: any;
};

export const useDeleteMilestoneActions =
  (): UseDeleteMilestoneActionsResult => {
    const { fetchMutation } = useFetchMutation();

    const { mutate, isLoading, isSuccess, error } = useMutation(
      (data: UseDeleteMilestoneActionsArguments) =>
        fetchMutation({
          path: `/v2/cases/${data.caseId}/milestones/actions/${data.actionId}`,
          method: 'DELETE',
          invalidateQueries: [['cases']],
          successToastMessage: data.successToastMessage,
          disableErrorToast: true,
        }),
    );

    return {
      deleteMilestoneActionsMutate: mutate,
      isLoading,
      isSuccess,
      error,
    };
  };
